<template>
  <div class="card">
    <div class="title" style="overflow: hidden">
      <div
        style="margin-top:3px;width:4px;height:16px;background:#3D73DD;margin-right:9px;float:left"
      ></div>
      <div
        style="float:left;font-size:16px;font-family: PingFangSC-Semibold;color:#1C2D51;font-weight: 600;line-height:22px;"
      >
        {{ title }}
      </div>
      <div class="more" @click="onClick">
        更多
        <a-icon type="double-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    moreClick: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    onClick() {
      if (this.moreClick) {
        this.moreClick(this.id)
      }
    }
  }
}
</script>

<style scoped lang="less">
.card {
  .title {
    position: relative;
    .more {
      position: absolute;
      right: 20px;
      color: #3d73dd;
      cursor: pointer;
      font-size: 14px;
    }
    .more:hover {
      color: #0f3e92;
    }
  }
}
</style>
